import { Row, Card, Col, Image, Table, Form, Skeleton, Button, message } from "antd";
import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import * as invoiceDataService from "../../services/AllInvoices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import PlaceHolderImg from '../../assets/images/logoPlaceholder.png'
import { formatCurrency } from "../../utils/formatCurrency";
import moment from "moment";
const SingleInvoice = () => {
  var dispatch = useDispatch();
  const [invoiceData, setInvoiceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [continueLoading, setContinueLoading] = useState(false);
  // const size = 'large';
  let navigate = useNavigate();
  const userDetails = useSelector((state) => state.User.userDetails);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails]);

  const fetchData = (params = {}) => {
    setLoading(true);
    const queryParams = new URLSearchParams(window.location.search);
    const invoice_id = queryParams.get("invoice_id");
    console.info("IdInvoice", invoice_id);
    dispatch(invoiceDataService.getInvoiceData(invoice_id))
      .then((res) => {
        console.info("invoicedata", res);
        setInvoiceData(res);
        setLoading(false);
      })
      .catch((err) => {
        console.info("Get Error Edit State...");
        setLoading(false);
      });
  };

  const getPdf = () => {
    setContinueLoading(true);
    const queryParams = new URLSearchParams(window.location.search);
    const invoice_id = queryParams.get("invoice_id");
    console.info("invoice_id", invoice_id);
    dispatch(invoiceDataService.getInvoicePdf(invoice_id))
      .then((res) => {
        setContinueLoading(false);
        console.info("getInvoicePdf", res?.data);
        if (invoiceData.cover_generated === "NO") {
          navigate("/create-cover-letter/?req_id=" + invoiceData.req_id);
        } else {
          navigate("/cover-letter/?cover_id=" + invoiceData.cover_id);
        }
      })
      .catch((err) => {
        setContinueLoading(false);
        console.error("Error proceeding to cover letter:", err);
        message.error("Failed to proceed to cover letter");
      });
  };

  const downloadPdf = () => {
    setDownloadLoading(true);
    const queryParams = new URLSearchParams(window.location.search);
    const invoice_id = queryParams.get("invoice_id");
    console.info("invoice_id", invoice_id);
    dispatch(invoiceDataService.getInvoicePdf(invoice_id))
      .then((res) => {
        setDownloadLoading(false);
        const fileUrl = res?.data;
        if (fileUrl && typeof fileUrl === "string" && fileUrl.startsWith("http")) {
          const link = document.createElement("a");
          link.href = fileUrl;
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          link.setAttribute("download", `Invoice-${invoice_id}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          message.success("Invoice PDF download started!");
        } else {
          message.error("Unable to retrieve invoice PDF URL");
        }
      })
      .catch((err) => {
        setDownloadLoading(false);
        console.error("Error downloading invoice PDF:", err);
        message.error("Failed to download invoice PDF");
      });
  };
  const columns = [
    {
      title: "S.No.",
      dataIndex: "index",
      key: "index",
      width: "10%",
      render: (id, record, index) => { ++index; return index; },
    },

    {
      title: "Service",
      dataIndex: "service",
      key: "service",
      width: "70%",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (text || text === 0) ? `$${formatCurrency(text)}` : "-",
    },
  ];

  const handleNavigate = () => {
    navigate("/update-invoice/?invoice_id=" + invoiceData.invoice_id)
  }

  return (
    <div className="singleReportWrapper">
      <div className="pageHeader">
        <PageHeader
          title="Single Invoice"
        />
      </div>
       <div className="buttonSection">
        <div className="container-xxl">
          <Row>
            <Col xs={24} md={24} className="text-end">
              {userDetails?.user_role === "um_inspector" ? (
                <Button
                  type='success'
                  className="btn inspectionAdd" 
                  onClick={() => handleNavigate()}
                >
                  Edit Invoice
                </Button>
              ) : (
                ''
              )}
              
            </Col>
          </Row>
        </div>
      </div>
      <div className="container-xxl">
        {loading ? (
          <div className="">
          <div className="Skeleton_invoice">
              <Row gutter={16} className="mb-4 mt-4" justify="space-between">
                <Col xs={24} md={8} xl={8} className="">
                  <Row gutter={16} className="mb-3">
                    <Col xs={24} md={18} xl={18} className="">
                    <Skeleton.Input block={true} active size="large" style={{height:"90px" }}/>
                    </Col>
                    <Col xs={24} md={6} xl={6} className="">
                    </Col>
                  </Row>
                  <Row gutter={16} className="mb-5" >
                    <Col xs={24} md={12} xl={12} className="sklpad">
                    <Skeleton />
                    </Col>
                    <Col xs={24} md={12} xl={12} className="sklpad">
                    </Col>
                  </Row>
                  <Row gutter={16} className="mt-5" >
                    <Col xs={24} md={24} xl={24} className="sklpad">
                    <Skeleton />
                    </Col>
                    <Col xs={24} md={12} xl={12} className="sklpad">
                    </Col>
                  </Row> 
                </Col>
                <Col xs={24} md={6} xl={6} className="">
                  <Row gutter={16} className="">
                  <Col xs={24} md={24} xl={24} className="sklpad">
                    <Skeleton.Input block={true} active size="large" />
                  </Col>
                  </Row>
                  <hr></hr>
                  <Row gutter={16} className="mt-4 mb-4">
                  <Col xs={24} md={24} xl={24} className="sklpad">
                    <Skeleton.Input block={true} active size="large" />
                  </Col>
                  </Row>
                  <Row gutter={16} className="mb-4">
                  <Col xs={24} md={24} xl={24} className="sklpad">
                    <Skeleton.Input block={true} active size="large" />
                  </Col>
                  </Row>
                  <Row gutter={16} className="mb-4">
                  <Col xs={24} md={24} xl={24} className="sklpad">
                    <Skeleton.Input block={true} active size="large" />
                  </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16} className="mb-4">
                <Col md={24}>
                <Skeleton.Input block={true} active size="large" style={{height:"110px" }}/>
                </Col>
              </Row>
              <Row gutter={16} className="mb-5" justify="space-between">
                <Col xs={24} md={18} xl={8} className="">
                </Col>
                <Col xs={24} md={6} xl={6} className="sklpad">
                <Skeleton.Input block={true} active size="large" />
                </Col>
              </Row>
              <Row gutter={16} className="mb-5 mt-4">
                <Col md={24}>
                  <Skeleton.Input block={true} active size="large" />
                </Col>
              </Row>
              <Row gutter={16} className="mb-5" justify="center">
                <Col xs={24} md={9} xl={9} className="sklpad">
                
                </Col>
                <Col xs={24} md={6} xl={6} className="sklpad">
                <Skeleton.Input block={true} active size="large" />
                </Col>
                <Col xs={24} md={9} xl={9} className="sklpad">
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <div className="srWrapperInner">
            <Form name="report" autoComplete="off" layout="vertical">
              <Card className="reportCard invoice-section-card-content" id="quickReportContent">
                <div className="reportCardBody">
                  <div className="inspectorInfo">
                    <Row gutter={30}>
                      <Col xs={24} md={6}>
                        <div className="inspectorLogo">
                          <Image
                            src={invoiceData?.logo_url ? invoiceData?.logo_url : PlaceHolderImg}
                            className="ing-fluid"
                            alt="InspectorLogo"
                            preview={false}
                          />
                          <div className="adminInfo">
                            <p>{invoiceData?.ins_organization_name}</p>
                            <p>{invoiceData?.ins_address}</p>
                            <p>{invoiceData?.ins_phone_number}</p>
                            <p>{invoiceData?.ins_email}</p>
                          </div>
                        </div>
                      </Col>
                      <Col sx={24} md={12}></Col>
                      <Col xs={24} md={6}>
                        <div className="inspectorDetails">
                          <div className="inspecDetailHead">
                            <h5 className="inspcTitle">Invoice</h5>
                          </div>
                          <div className="inspcInfo">
                            <div className="formGroup">
                              <Form.Item
                                className="mb-1"
                                label="Invoice"
                                name="invoice"
                              >
                                <p className="formControl">
                                  {invoiceData?.invoice ? invoiceData?.invoice : '-'}
                                </p>
                              </Form.Item>
                            </div>
                            <div className="formGroup">
                              <Form.Item
                                className="mb-1"
                                label="Claim"
                                name="claim"
                              >
                                <p className="formControl">
                                  {invoiceData?.claimnumber ? invoiceData?.claimnumber : '-'}
                                </p>
                              </Form.Item>
                            </div>
                            <div className="formGroup">
                              <Form.Item  
                                className="mb-1"
                                label="Date"
                              >
                                {console.info('invoiceData?.invoice_date', invoiceData?.invoice_date)}
                                <p className="formControl">{invoiceData?.invoice_date ? moment(invoiceData.invoice_date).format('MM-DD-YYYY') : '-'}</p>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="inspectorDetails">
                    <div className="inovicecards my-3">
                      <Row gutter={16}>
                        <Col xs={24} md={8} xl={8}>
                          <p className="siboxheading">Bill To :</p>
                          <Card className="inovicecard">

                            <p>{invoiceData?.client_name}</p>
                            <p>{invoiceData?.company_name}</p>
                            <p>{invoiceData?.addressdiv}</p>
                            <p>{invoiceData?.phone_personal}</p>
                            <p>{invoiceData?.email_address}</p>
                          </Card>
                        </Col>

                        {invoiceData?.gc_subdivision && invoiceData?.gc_subdivision[0] !== null && invoiceData?.gc_subdivision[0][0] !== '' ? (
                          <Col xs={24} md={8} xl={8}>
                            <p className="siboxheading">Sub Division</p>
                            <Card className="inovicecard">
                              <div>
                                
                           {Array.isArray(invoiceData?.gc_subdivision[0]) ? invoiceData?.gc_subdivision[0].map(name => <p> {name} </p>) : invoiceData?.gc_subdivision[0]}
                              </div>
                            </Card>
                        </Col>
                        ) : (
                          ""
                        )}
                        
                        {invoiceData?.gc_lotnumber && invoiceData?.gc_lotnumber[0] !== null && invoiceData?.gc_lotnumber[0][0] !== '' ? (
                          <Col xs={24} md={8} xl={8}>
                            <p className="siboxheading">Lot Number</p>
                            <Card className="inovicecard">
                              <div>
                              {Array.isArray(invoiceData?.gc_lotnumber[0]) ? invoiceData?.gc_lotnumber[0].map(name => <p> {name} </p>) : invoiceData?.gc_lotnumber[0]}
                              </div>
                      
                            </Card>
                        </Col>
                        ) : (
                          ""
                        )}
                      </Row>
                    </div>
                  </div>
                  {invoiceData?.show_homeowner === '1' && (
                  <div className="invoice-home-owner-details mb-3">
                      <div>
                        <h5 className="inspcTitle mb-3">Homeowner/End-User Information</h5>
                        <Row gutter={16}>
                          <Col xs={24} md={8} xl={8}>
                          <div className="formGroup">
                              <Form.Item
                                className="mb-2"
                                label="Homeowner/End-User Name"
                                name="h_eu_name"
                              >
                                <p className="formControl">
                                  {invoiceData?.h_eu_name ? invoiceData?.h_eu_name : '-'}
                                </p>
                              </Form.Item>
                            </div>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <div className="formGroup">
                              <Form.Item
                                className="mb-2"
                                label="Street Name/Number"
                                name="h_eu_street"
                              >
                                <p className="formControl">
                                  {invoiceData?.h_eu_street ? invoiceData?.h_eu_street : '-'}
                                </p>
                              </Form.Item>
                            </div>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <div className="formGroup">
                              <Form.Item
                                className="mb-2"
                                label="City"
                                name="h_eu_city"
                              >
                                <p className="formControl">
                                  {invoiceData?.h_eu_city ? invoiceData?.h_eu_city : '-'}
                                </p>
                              </Form.Item>
                            </div>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <div className="formGroup">
                              <Form.Item
                                className="mb-2"
                                label="State/Province"
                                name="h_eu_stateProvince"
                              >
                                <p className="formControl">
                                  {invoiceData?.h_eu_stateProvince ? invoiceData?.h_eu_stateProvince : '-'}
                                </p>
                              </Form.Item>
                            </div>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <div className="formGroup">
                              <Form.Item
                                className="mb-2"
                                label="Country"
                                name="claim"
                              >
                                <p className="formControl">
                                  {invoiceData?.h_eu_country ? invoiceData?.h_eu_country : '-'}
                                </p>
                              </Form.Item>
                            </div>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                              <div className="formGroup">
                              <Form.Item
                                className="mb-2"
                                label="Zip/Postal Code"
                                name="claim"
                              >
                                <p className="formControl">
                                  {invoiceData?.zip_code ? invoiceData?.zip_code : '-'}
                                </p>
                              </Form.Item>
                            </div>
                            
                          </Col>

                          </Row>
                      </div>
                    </div>
                  )}   
                </div>
                <div className="invoiceTable">
                  <Table
                    columns={columns}
                    dataSource={invoiceData.servicerepeater}
                    rowKey={(invoiceData) => invoiceData.servicerepeater}
                    pagination={false}
                    bordered
                  />
                </div>
                <div className="custom-Content">
                  <Row gutter={16} className="crbtn">
                    <Col xs={24} md={6} xl={6}>
                      <div className="formGroup total-balance-box">
                        <Form.Item label="Balance Due : $" name="blnc-due">
                          <p className="formControl">{formatCurrency(invoiceData?.total)}</p>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Row gutter={16} className="crbtn invoice-single-notes">
                  <Col xs={24} md={24} xl={24}>
                    <div className="formGroup">
                      <Form.Item label="Notes" name="notes" className="invoice-notes">
                        <p className="formControl">{invoiceData?.invoice_notes ? invoiceData?.invoice_notes : '-'}</p>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row gutter={16} className="crbtn">
                  <Col xs={24} md={24} xl={24}>
                    <div className="formGroup">
                    {invoiceData?.invoice_extra_notes !== "" ? (
                          <div className="formGroup">
                            <pre>{invoiceData?.invoice_extra_notes}</pre>

                          </div>
                        ) : (
                          <div className="formGroup"></div>
                        )}
                    </div>
                  </Col>
                </Row>
              </Card>
              <Row gutter={16} className="sibtn">
                <Col xs={24} md={24}>
                  <div className="text-center my-3">
                    {userDetails?.user_role === "um_inspector" ? (
                      <>
                        <Button
                          className="btnPrimary me-2"
                          style={{ marginRight: "10px" }}
                          onClick={() => downloadPdf()}
                          loading={downloadLoading}
                        >
                          Download Invoice PDF
                        </Button>
                        <Button
                          className="btnPrimary"
                          onClick={() => getPdf()}
                          loading={continueLoading}
                        >
                          Save and Continue to Cover Letter
                        </Button>
                      </>
                    ) : (
                      <Button
                        className="btnPrimary"
                        onClick={() => downloadPdf()}
                        loading={downloadLoading}
                      >
                        Download PDF
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleInvoice;
